import {combineReducers} from 'redux';

import user from './user';
import error from './error';
import responsive from "./responsive";

const reducers = {
    user,
    error,
    responsive
};

export default combineReducers(reducers);
